// src/components/validate.js (adjust path as needed)
import i18next from 'i18next';
import { object, string } from 'yup';

export default () => {
    return object().shape({
        name: string().required(i18next.t('Title cannot be empty')).nullable(),
        language: string() // Optional: add validation if needed
            .nullable(),
    });
};
